import React from 'react';
import styled from 'styled-components';
import { TbLink } from 'react-icons/tb';
import { isMobile } from '../common/style';

const ShareLinkBtn = () => {
  const ClipBoard = () => {
    const nowUrl = 'https://balabalancegame.netlify.app';

    navigator.clipboard.writeText(nowUrl).then(() => {
      alert('공유 링크가 복사되었습니다');
    });
  };

  return (
    <ShareBtn onClick={ClipBoard}>
      <TbLink className="icons" color="#566D62" />
    </ShareBtn>
  );
};
export default ShareLinkBtn;

const ShareBtn = styled.button`
  width: 86px;
  height: 86px;
  padding: 16px;
  border-radius: 100px;
  background: #dcf0e9;
  border: 3px solid #3d6c5b;
  box-shadow: 2px 3px 4px rgba(0, 0, 0, 0.25);

  &:hover {
    cursor: pointer;
    background: #86baa7;
  }

  ${isMobile} {
    width: 50px;
    height: 50px;
    padding: 8px;
    border: 2px solid #3d6c5b;
  }

  .icons {
    font-size: 48px;

    ${isMobile} {
      font-size: 27px;
    }
  }
`;
